import {type PlayerColor} from '@colonist/game-states'
import {type PlayerValidator} from '@colonist/game-mechanic-validators'
import {type MapValidator} from '../core/map/MapValidator.ts'

export abstract class MechanicValidator {
    protected readonly playerValidators: Map<PlayerColor, PlayerValidator>
    protected readonly mapValidator: MapValidator

    constructor(playerValidators: PlayerValidator[], mapValidator: MapValidator) {
        this.playerValidators = new Map()
        for(const playerValidator of playerValidators) {
            this.playerValidators.set(playerValidator.color, playerValidator)
        }

        this.mapValidator = mapValidator
    }
}
